<div class="client_pageBody space_book_page lg:max-w-[500px]">
  <div class="flex justify-center mb-8">
    <div class="stepper">
      <!--1-->
      <ng-container *ngIf="step<=0">
        <div class="stepper_item current">1</div>
        <div class="progressbar"></div>
      </ng-container>
      <ng-container *ngIf="step>0">
        <div>
          <img src="/silone/silone_step.png" />
        </div>
        <div class="progressbar completed"></div>
      </ng-container>

      <!--2-->
      <ng-container *ngIf="step<=1">
        <div class="stepper_item" [class.current]="step>0">2</div>
      </ng-container>
      <ng-container *ngIf="step>1">
        <div>
          <img src="/silone/silone_step.png" />
        </div>
      </ng-container>
      <div class="progressbar" [class.completed]="step>1"></div>

      <!--3-->
      <ng-container *ngIf="step<=2">
        <div class="stepper_item" [class.current]="step>1">3</div>
      </ng-container>
      <ng-container *ngIf="step>2">
        <div>
          <img src="/silone/silone_step.png" />
        </div>
      </ng-container>
      <div class="progressbar" [class.completed]="step>2"></div>

      <!--4-->
      <div class="stepper_item" [class.current]="step>2">4</div>
    </div>
  </div>
  <div class="flex justify-center mb-8">
    <!-- step 1-->
    <div *ngIf="step==0" class="space-y-6 w-full">
      <div class="text-2xl font-bold text-center">
        {{_common.findSpace.whatActivity}}
      </div>
      <div class="space-y-2">
        <div class="grid grid-cols-2 gap-2 w-full sm:grid-cols-4">
          <div class="client_itemSelect" *ngFor="let t of spaceTypes" [class.selected]="spaceType.includes(t)"
            (click)="toggleSpace(t)">
            {{lang(t.name, t.name_lang)}}

            <ng-container *ngIf="spaceType.includes(t)">
              <fa-icon icon="circle-check" class="selected_icon"></fa-icon>
            </ng-container>
          </div>
        </div>
        <div class="client_itemSelect" [class.selected]="allSpaceTypes" (click)="clearSpace()">
          {{_common.findSpace.notDecided}}
          <ng-container *ngIf="allSpaceTypes">
            <fa-icon icon="circle-check" class="selected_icon"></fa-icon>
          </ng-container>
        </div>
      </div>

      <div class="flex items-center justify-center">
        <button (click)="step1()" class="client_button" [disabled]="!spaceType" [class.disabled]="!spaceType">
          {{_common.next}}
        </button>
      </div>
    </div>

    <!-- step 2-->
    <div *ngIf="step==1" class="space-y-6 w-full">
      <div class="text-2xl font-bold text-center">
        {{_common.findSpace.where}}
      </div>
      <div class="flex flex-col gap-2 items-center">
        <app-form-field class="w-full max-w-[330px]">
          <!-- <app-label>{{_common.Area}}</app-label> -->
          <mat-select [(ngModel)]="area" (selectionChange)="updateArea()">
            <mat-option value="">{{_common.Filter.any_area}}</mat-option>
            <mat-option value="HK">{{_common.HK}}</mat-option>
            <mat-option value="KLN">{{_common.KLN}}</mat-option>
            <mat-option value="NT">{{_common.NT}}</mat-option>
          </mat-select>
        </app-form-field>
        <ng-container *ngIf="area != ''">
          <app-form-field class="w-full max-w-[330px]">
            <mat-select [(ngModel)]="district">
              <mat-option value="">{{_common.Filter.any_district}}</mat-option>
              <ng-container *ngIf="area == 'HK'">
                <mat-option value="HK_CS">{{_common.HK_CS}}</mat-option>
                <mat-option value="HK_WC">{{_common.HK_WC}}</mat-option>
                <mat-option value="HK_E">{{_common.HK_E}}</mat-option>
                <mat-option value="HK_S">{{_common.HK_S}}</mat-option>
              </ng-container>
              <ng-container *ngIf="area == 'KLN'">
                <mat-option value="KLN_YTM">{{_common.KLN_YTM}}</mat-option>
                <mat-option value="KLN_SSP">{{_common.KLN_SSP}}</mat-option>
                <mat-option value="KLN_KC">{{_common.KLN_KC}}</mat-option>
                <mat-option value="KLN_WTS">{{_common.KLN_WTS}}</mat-option>
                <mat-option value="KLN_KT">{{_common.KLN_KT}}</mat-option>
              </ng-container>
              <ng-container *ngIf="area == 'NT'">
                <mat-option value="NT_KT">{{_common.NT_KT}}</mat-option>
                <mat-option value="NT_TW">{{_common.NT_TW}}</mat-option>
                <mat-option value="NT_TM">{{_common.NT_TM}}</mat-option>
                <mat-option value="NT_YL">{{_common.NT_YL}}</mat-option>
                <mat-option value="NT_N">{{_common.NT_N}}</mat-option>
                <mat-option value="NT_TP">{{_common.NT_TP}}</mat-option>
                <mat-option value="NT_ST">{{_common.NT_ST}}</mat-option>
                <mat-option value="NT_SK">{{_common.NT_SK}}</mat-option>
                <mat-option value="NT_Islands">{{_common.NT_Islands}}</mat-option>
              </ng-container>
            </mat-select>
          </app-form-field>
        </ng-container>
      </div>
      <div class="flex items-center justify-center gap-6">
        <button (click)="step0()" class="client_button btn_outline">
          {{_common.back}}
        </button>
        <button (click)="step2()" class="client_button">
          {{_common.next}}
        </button>
      </div>
    </div>

    <!-- step 3-->
    <div *ngIf="step==2" class="space-y-6 w-full">
      <div class="text-2xl font-bold text-center">
        {{_common.findSpace.ppl}}
      </div>
      <div class="space-y-2">
        <div class="grid grid-cols-2 gap-2 sm:grid-cols-4">
          <div class="client_itemSelect" *ngFor="let o of capacities" [class.selected]="o==capacity"
            (click)="capacity=o">
            <ng-container *ngIf="o.min && o.max">
              {{ o.min }}-{{ o.max }}
            </ng-container>
            <ng-container *ngIf="o.min && !o.max">
              {{_common.findSpace.ppl_above_en}} 20{{_common.findSpace.ppl_above_zh}}
            </ng-container>
            <ng-container *ngIf="o==capacity">
              <fa-icon icon="circle-check" class="selected_icon"></fa-icon>
            </ng-container>
          </div>
        </div>
        <div class="client_itemSelect" [class.selected]="capacity==allCapacity" (click)="capacity=allCapacity">
          {{_common.findSpace.notDecided}}
          <ng-container *ngIf="capacity==allCapacity">
            <fa-icon icon="circle-check" class="selected_icon"></fa-icon>
          </ng-container>
        </div>
      </div>

      <div class="flex items-center justify-center gap-6">
        <button (click)="step1()" class="client_button btn_outline">
          {{_common.back}}
        </button>
        <button (click)="step3()" class="client_button" [disabled]="!capacity" [class.disabled]="!capacity">
          {{_common.next}}
        </button>
      </div>
    </div>

    <!-- Step 4-->
    <div *ngIf="step==3" class="space-y-6 w-full">
      <div class="text-2xl font-bold text-center">
        {{_common.findSpace.when}}
      </div>
      <div class="flex flex-col gap-2 items-center">
        <div class="text-center font-bold">
          {{_common.findSpace.select_date}}
        </div>
        <app-form-field class="w-full max-w-[330px]">
          <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate" [(ngModel)]="date" />
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </app-form-field>
      </div>
      <div class="flex flex-col gap-2 items-center">
        <div class="text-center font-bold">
          {{_common.findSpace.start_time}}
        </div>
        <app-form-field class="w-full max-w-[330px]">
          <mat-select [(ngModel)]="hour">
            <mat-option [value]="allHours">{{_common.findSpace.any_time}}</mat-option>
            <mat-option *ngFor="let h of hours" [value]="h.hour">
              {{h.text}}
            </mat-option>
          </mat-select>
        </app-form-field>
      </div>
      <div class="flex items-center justify-center gap-6">
        <button (click)="step2()" class="client_button btn_outline">
          {{_common.back}}
        </button>
        <button (click)="proceed()" class="client_button">
          {{_common.search}}
        </button>
      </div>
    </div>
  </div>
</div>